import { render } from "./InfoBlueIcon.vue?vue&type=template&id=8e80130e"
import script from "./InfoBlueIcon.vue?vue&type=script&lang=js"
export * from "./InfoBlueIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__